(function () {
  function initStickyAtc(root) {
    var scope = root || document;
    var bar = scope.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var titleTarget = bar.querySelector('[data-sticky-atc-title]');
    var priceTarget = bar.querySelector('[data-sticky-atc-price]');
    var variantTarget = bar.querySelector('[data-sticky-atc-variant]');
    var stickyButton = bar.querySelector('[data-sticky-atc-button]');
    var isInputFocused = false;

    function getMainButton() {
      return document.querySelector('[id^="ProductSubmitButton-"]');
    }

    function isFormField(target) {
      if (!target || target.nodeType !== 1) return false;
      if (target.isContentEditable || target.matches('textarea, select')) return true;
      if (!target.matches('input')) return false;

      var type = (target.getAttribute('type') || 'text').toLowerCase();
      return ['button', 'hidden', 'image', 'reset', 'submit'].indexOf(type) === -1;
    }

    function submitMainAddToCart(mainButton) {
      if (!mainButton) return;
      var form = mainButton.form || mainButton.closest('form');
      if (!form) {
        mainButton.click();
        return;
      }
      if (typeof form.requestSubmit === 'function') {
        try {
          form.requestSubmit(mainButton);
        } catch (e) {
          mainButton.click();
        }
      } else {
        mainButton.click();
      }
    }

    function syncContent() {
      var mainButton = getMainButton();
      var titleSource = document.querySelector('.product__title h1');
      var priceSource = document.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale, [id^="price-"] .price-item:last-child');
      var selectedValues = Array.prototype.slice
        .call(document.querySelectorAll('variant-selects [data-selected-value]'))
        .map(function (node) {
          return node.textContent.trim();
        })
        .filter(Boolean);

      if (!selectedValues.length) {
        selectedValues = Array.prototype.slice.call(document.querySelectorAll('variant-selects select')).map(function (select) {
          return select.options[select.selectedIndex] ? select.options[select.selectedIndex].text.trim() : '';
        });
      }

      if (titleSource && titleTarget) titleTarget.textContent = titleSource.textContent.trim();
      if (priceSource && priceTarget) priceTarget.textContent = priceSource.textContent.trim();
      if (variantTarget) variantTarget.textContent = selectedValues.filter(Boolean).join(' / ');

      if (mainButton && stickyButton) {
        stickyButton.disabled = mainButton.disabled;
        stickyButton.textContent = mainButton.textContent.trim();
      }
    }

    function syncVisibility() {
      var mainButton = getMainButton();
      if (!mainButton) return;
      var rect = mainButton.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0 && !isInputFocused);
    }

    isInputFocused = isFormField(document.activeElement);

    syncContent();
    syncVisibility();

    window.addEventListener('scroll', syncVisibility, { passive: true });
    window.addEventListener('resize', syncVisibility);

    document.addEventListener('focusin', function (event) {
      if (!isFormField(event.target)) return;
      isInputFocused = true;
      syncVisibility();
    });

    document.addEventListener('focusout', function () {
      window.setTimeout(function () {
        isInputFocused = isFormField(document.activeElement);
        syncVisibility();
      }, 0);
    });

    document.addEventListener('change', function (event) {
      if (event.target.closest('variant-selects') || event.target.closest('product-info')) {
        window.setTimeout(syncContent, 120);
        window.setTimeout(syncVisibility, 120);
      }
    });

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        submitMainAddToCart(getMainButton());
      });
    }

    var observer = new MutationObserver(function () {
      syncContent();
      syncVisibility();
    });

    var productInfo = document.querySelector('[id^="MainProduct-"]');
    if (productInfo) observer.observe(productInfo, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initStickyAtc(document);
    });
  } else {
    initStickyAtc(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initStickyAtc(event.target);
  });
})();
